"use client";

import type { ReactNode, CSSProperties } from "react";

interface MarqueeRowProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  reverse?: boolean;
  duration?: string;
  copies?: number;
}

export function MarqueeRow<T>({
  items,
  renderItem,
  reverse = false,
  duration = "40s",
  copies = 4,
}: MarqueeRowProps<T>) {
  return (
    <div className="w-full overflow-hidden" aria-hidden="true">
      <div
        className={`flex w-max gap-3 ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}
        style={{ "--duration": duration } as CSSProperties}
      >
        {Array.from({ length: copies }, (_, idx) => `copy-${idx}`).map((copyId, copyIdx) => (
          <div
            key={copyId}
            className="flex shrink-0 gap-3 pr-3"
            aria-hidden={copyIdx > 0 ? "true" : undefined}
          >
            {items.map((item, i) => renderItem(item, copyIdx * items.length + i))}
          </div>
        ))}
      </div>
    </div>
  );
}
